import { FC } from "react";
import { BlogPostSummaryProps } from "./types";
import { useRouter } from "next/router";

const BlogPostSummary: FC<BlogPostSummaryProps> = ({ summaryTitles }) => {
  const router = useRouter();

  return (
    <div className="max-w-2x">
      <h3 className="text-2xl font-semibold mb-6">Continut articol</h3>
      <div className="space-y-4">
        {summaryTitles?.map((item, idx) => (
          <div className="space-y-2" key={item?.key || idx}>
            <h4
              className="text-lg font-medium hover:text-primary transition-colors cursor-pointer hover:text-ekgreen hover:underline"
              onClick={() => {
                if (item?.key) {
                  const currentSlug = router.query.slug;
                  router.push(
                    {
                      pathname: `/blog/${Array.isArray(currentSlug) ? currentSlug.join("/") : currentSlug}`,
                      hash: item.key,
                    },
                    undefined,
                    { shallow: true }
                  );
                } else {
                  // We scroll to the element with text equal to item.title
                  const headers = document.querySelectorAll("h2");
                  const element = Array.from(headers).find((el) =>
                    el.textContent?.includes(item.title)
                  );
                  if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                  }
                }
              }}
            >
              {idx + 1}. {item?.title}
            </h4>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogPostSummary;
